<template>
  <div id="page-container" class="side-scroll page-header-modern main-content-narrow" :class="{'sidebar-o': sidebarOpen, 'sidebar-o-xs': sidebarOpen}">
    <vmc-sidebar @close-sidebar="sidebarOpen = false"></vmc-sidebar>
    <vmc-header @toggle-sidebar="sidebarOpen = !sidebarOpen"></vmc-header>
    <main id="main-container">
      <div class="content">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </main>
    <vmc-footer></vmc-footer>
  </div>
</template>

<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import Footer from './partials/Footer'

export default {
  components: {
    'vmc-sidebar': Sidebar,
    'vmc-header': Header,
    'vmc-footer': Footer
  },
  data () {
    return {
      sidebarOpen: true
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// DefaultLayout.vue?0f698a52